import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import TopBusinessQuotesWrapper from "@components/layouts/topBusinessQuotesWrapper";

export default function TopBusinessQuotesHome(): ReactElement {
    return (
        <TopBusinessQuotesWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#FCB02F" />
                </div>
                <FormSection iconsFillColor="#063C58" />
            </div>
        </TopBusinessQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
